import SEO from "../components/common/SEO";
import PageHero from "../components/common/PageHero";
import PillButton from "../components/common/PillButton";
import SectionHeading from "../components/common/SectionHeading";
import { StaggerGroup } from "../components/common/Reveal";
import TalentCard from "../components/cards/TalentCard";
import ProcessTimeline from "../components/home/ProcessTimeline";
import CTASection from "../components/common/CTASection";
import { talentServices } from "../data/talent";
import { useStaffing } from "../components/forms/StaffingProvider";

export default function TalentSolutions() {
  const { open } = useStaffing();
  return (
    <>
      <SEO
        title="Talent Solutions & IT Staffing"
        description="Contract staffing, contract-to-hire, direct hire, engineering staffing, dedicated teams and offshore development from AMVI Technologies."
        path="/talent-solutions"
      />
      <PageHero
        eyebrow="Talent Solutions"
        title="The Talent You Need. When You Need It."
        subtitle="Flexible talent solutions designed to help organizations scale faster and build high-performing teams."
        image="https://images.unsplash.com/photo-1531482615713-2afd69097998?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      >
        <div className="flex flex-col gap-4 sm:flex-row">
          <PillButton onClick={open} size="lg" testId="talent-hero-cta">Submit a Staffing Requirement</PillButton>
          <PillButton to="/contact" variant="outline" size="lg">Talk to an Expert</PillButton>
        </div>
      </PageHero>

      <section className="px-6 py-16 lg:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            eyebrow="Engagement Models"
            title="Six flexible ways to build your team"
            subtitle="From a single specialist to a fully dedicated offshore team, we match the model to your goals."
            testId="talent-models"
          />
          <StaggerGroup className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {talentServices.map((s) => (
              <TalentCard key={s.name} service={s} />
            ))}
          </StaggerGroup>
        </div>
      </section>

      <div className="border-t border-white/5">
        <ProcessTimeline />
      </div>

      <CTASection
        title="Submit a staffing requirement"
        subtitle="Tell us the roles you need and we'll get to work."
      />
    </>
  );
}
